var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPage)?_c('extra-content',{attrs:{"extra":_vm.extra}}):(_vm.menuHasCategory)?_c('extra-category-cards',{attrs:{"extra":_vm.extra}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }